import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { Publication } from '../interfaces/publications/interfaces';

@Injectable()
export class PublicationsService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  getPublications(): Observable<Publication[]> {
    this.endpoint = `${BASE_URL_CRUD}/publication/list?status=PUBLISHED&includeStatus=true`;
    return this.get(this.endpoint);
  }

  logView(data) {
    this.endpoint = `${BASE_URL_CRUD}/publication/view`;
    return this.post(this.endpoint, data);
  }

  logClick(publicationId) {
    this.endpoint = `${BASE_URL_CRUD}/publication/${publicationId}/click`;
    return this.put(this.endpoint, {});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/publications.service.ts